/**
 * Motivo da recusa, do jeito que os controllers do Kanban falam.
 *
 * São DUAS formas, e é por isso que a função existe em vez de um acesso direto:
 *
 *   `{ error: ... }`    — o que `destroy` renderiza à mão
 *                         (`PipelinesController#destroy`,
 *                         `PipelineStagesController#destroy`,
 *                         `KanbanStageAutomationsController`).
 *   `{ message: ... }`  — o que sai de `save!`/`update!`, pelo
 *                         `render_record_invalid` global do
 *                         `RequestExceptionHandler`.
 *
 * Quem lia só uma delas mostrava "Request failed with status code 422" na
 * outra metade dos casos, engolindo a frase que diz O QUE está errado ("2 deals
 * neste estágio bloqueiam a exclusão", "ação 2 (assign_team): falta team_id").
 *
 * Vive sozinho porque tem três donos (automações, passagens e o painel do
 * quadro). Nasceu como `automationErrorMessage` dentro do módulo de automações;
 * quando o painel do quadro precisou do mesmo tratamento pra funil e fase, a
 * escolha era copiar a função ou movê-la — e cópia de regra é o modo de falha
 * que este repo já pagou caro.
 *
 * `null` quando não há nada legível: quem chama decide o texto genérico.
 */
export const kanbanErrorMessage = error =>
  error?.response?.data?.error ||
  error?.response?.data?.message ||
  error?.message ||
  null;

export default kanbanErrorMessage;
